// src/components/Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebaseClient';
import './Auth.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  // Wenn bereits eingeloggt, sofort zum Dashboard weiterleiten
  useEffect(() => {
    if (auth.currentUser) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard');
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setMessage('Bitte geben Sie Ihre E-Mail-Adresse ein, um das Passwort zurückzusetzen.');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Ein Passwort-Zurücksetzungslink wurde an Ihre E-Mail-Adresse gesendet.');
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-left">{/* Das Logo wird als Hintergrund angezeigt */}</div>
      <div className="auth-right">
        <form className="auth-form" onSubmit={handleLogin}>
          <h2>Login</h2>
          {message && <p style={{ color: 'red' }}>{message}</p>}
          <input 
            type="email" 
            placeholder="E-Mail" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
            required 
          />
          <input 
            type="password" 
            placeholder="Passwort" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)}
            required 
          />
          <button type="submit">Einloggen</button>
          <span 
            className="forgot-password"
            onClick={handleForgotPassword}
          >
            Passwort vergessen?
          </span>
          <div className="switch-auth">
            <p>Noch kein Konto? <Link to="/signup">Registrieren</Link></p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
